import { useAppSelector } from "redux-share";
import { conditions } from "../../../../../helpers";
import { ConditionName, IDislikeIconProps } from "../../../../../interfaces";
import { shallowEqual } from "react-redux";

const DislikeIcon = (props: IDislikeIconProps) => {
    useAppSelector(({ user: { videoSettings } }) => ({ videoSettings }), shallowEqual);
    useAppSelector(
        ({ videoData: { isComplexPortrait, videoElementSizeInfo, params } }) => ({ isComplexPortrait, videoElementSizeInfo, params }),
        shallowEqual
    );
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`${props.isDislike ? "fa-solid" : "fa-light"} fa-thumbs-down pl-text-white pl-cursor-pointer pl-flex pl-items-center ${
                        conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"
                    }`}
                    onClick={props.onClick}
                    onDoubleClick={props.onDoubleClick}
                />
            ) : (
                <svg
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 16 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 16 : 22}
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={props.onClick}
                    onDoubleClick={props.onDoubleClick}
                    className={props.className}
                >
                    <path d="M7.6909 5.04091V14.3542C7.6909 14.7209 7.8009 15.0784 8.00257 15.3809L10.5051 19.1026C10.8992 19.6984 11.8801 20.1201 12.7142 19.8084C13.6126 19.5059 14.2084 18.4976 14.0159 17.5992L13.5392 14.6017C13.5026 14.3267 13.5759 14.0792 13.7317 13.8867C13.8876 13.7126 14.1167 13.6026 14.3642 13.6026H18.1317C18.8559 13.6026 19.4792 13.3092 19.8459 12.7959C20.1942 12.3009 20.2584 11.6592 20.0292 11.0084L17.7742 4.14258C17.4901 3.00591 16.2526 2.08008 15.0242 2.08008H11.4492C10.8351 2.08008 9.9734 2.29091 9.57923 2.68508L8.4059 3.59258C7.95673 3.94091 7.6909 4.47258 7.6909 5.04091Z" />
                    <path d="M4.77608 16.143H3.83192C2.41108 16.143 1.83358 15.593 1.83358 14.2364V5.02385C1.83358 3.66719 2.41108 3.11719 3.83192 3.11719H4.77608C6.19691 3.11719 6.77441 3.66719 6.77441 5.02385V14.2455C6.77441 15.593 6.19691 16.143 4.77608 16.143Z" />
                </svg>
            )}
        </>
    );
};

export default DislikeIcon;
